module.exports = __webpack_public_path__ + "img/resume-parser.088226ce.svg";